import { z } from "zod";
import { zId, zSortDir } from "./common.js";
import { zSegmentDefinition } from "./segment.js";

export const VIEW_OBJECTS = ["constituent", "gift", "pledge", "task", "grant", "event"] as const;
export const zViewObject = z.enum(VIEW_OBJECTS);

export const VIEW_LAYOUTS = ["list", "board", "calendar", "timeline"] as const;
export const zViewLayout = z.enum(VIEW_LAYOUTS);

export const zSavedView = z.object({
  id: zId,
  object: zViewObject,
  name: z.string(),
  layout: zViewLayout,
  filters: zSegmentDefinition.nullable(),
  columns: z.array(z.string()),
  sortField: z.string().nullable(),
  sortDir: zSortDir.nullable(),
  groupBy: z.string().nullable(),
  isShared: z.boolean(),
  ownerId: zId,
  createdAt: z.string(),
});
export type SavedView = z.infer<typeof zSavedView>;

export const zUpsertSavedView = z.object({
  object: zViewObject,
  name: z.string().trim().min(1).max(120),
  layout: zViewLayout.default("list"),
  filters: zSegmentDefinition.nullable().optional(),
  columns: z.array(z.string()).max(40).default([]),
  sortField: z.string().optional(),
  sortDir: zSortDir.optional(),
  groupBy: z.string().optional(),
  isShared: z.boolean().default(false),
});
